/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/8/7
 * Time: 10:49
 * Desc: 分销报表
 */

import { Component, Vue, Watch } from 'vue-property-decorator';
import moment from 'moment';
import { IPSService } from '@/services/ipsServices';
import NoAuth from '@/views/components/noAuth/noAuth.vue';
import ExportFile from '@/views/components/exportFile';
import { parseSec } from '@/util';
@Component({
  components: {
    NoAuth,
    ExportFile,
  },
})
export default class TransactionStatistics extends Vue {
  /* 数据 */

  /**
   * loading状态
   * @type {boolean}
   */
  public loadingState = false;

  /**
   * 分销列表
   * @type {Array<ItemObject>}
   */
  public distributeList: Array<ItemObject> = [];
  public defaultStart: Date | number;

  public defaultEnd: Date | number;
  /**
   * 页码
   * @type {number}
   */
  public page = 1;

  /**
   * 条数
   * @type {number}
   */
  public pageSize = 10;

  /**
   * 总条数
   * @type {number}
   */
  public totalCount = 0;

  /**
   * 关键字
   * @type {string}
   */
  public keywords = '';

  /**
   * 内容是否显示
   * @type {boolean}
   */
  public isContentBodyShow = false;

  isShowCode = false;
  /**
   *  导出按钮的信息
   * @type {ItemObject}
   */
  public exportBtnInfo: Array<ItemObject> = [
    {
      state: 0,
      url: '',
    },
    {
      state: 0,
      url: '',
    },
  ];

  public index = 0;

  /**
   * socket连接准备
   * @type {boolean}
   */
  public isSocketReady = false;

  public date = [];
  actIds = [];

  get exportParams() {
    return {
      exportType: 'fxSuccessReport',
      params: {
        keywords: this.keywords,
        siteIds: this.actIds,
        startOfTime: parseSec(1, this.date[0]) || '',
        endOfTime: parseSec(2, this.date[1]) || '',
      },
    };
  }

  get exportParamsDetail() {
    const postParams = {
      exportType: 'allProfitIn',
      params: {
        siteId: this.actIds,
        keywords: this.keywords,
      },
    };
    if (this.date && this.date.length) {
      const sTime = parseSec(5, this.date[0]) || '';
      const eTime = parseSec(6, this.date[1]) || '';
      postParams.params['startTime'] = moment(sTime).format('YYYY-MM-DD HH:mm:ss');
      postParams.params['endTime'] = moment(eTime).format('YYYY-MM-DD HH:mm:ss');
    }
    return postParams;
  }

  /* 方法 */
  /**
   * 条数变更
   * @ {number} val
   * @return null
   */
  public onSizeChange(val: number): void {
    this.page = 1;
    this.pageSize = val;
    this.getDistributeList();
  }

  public dateChange() {
    this.page = 1;
    this.getDistributeList();
  }

  /**
   * 页码变更
   * @ {number} val
   * @return null
   */
  public onPageChange(val: number): void {
    this.page = val;
    this.getDistributeList();
  }

  /**
   * 关键字搜索
   * @return null
   */
  public onSearchByKeyWords(): void {
    this.page = 1;
    this.pageSize = 10;
    this.getDistributeList();
  }

  public goDetail(siteId, siteName, index, date) {
    const sTime = Date.parse(date[0]) / 1000 || '';
    const eTime = Date.parse(date[1]) / 1000 || '';
    date = [sTime, eTime];
    this.$router.push({ path: `/distributeBoard/info/${siteId}`, query: { siteName, index, dater: date } });
  }

  handleSelectionChange(val) {
    this.actIds = val.map((i) => {
      return i.siteId;
    });
  }

  showInfo() {
    this.isShowCode = true;
  }

  public closeInfo(): void {
    this.isShowCode = false;
  }

  /**
   * 获取列表
   * @return null
   */
  public getDistributeList(): void {
    this.distributeList = [];
    const postParams = {
      page: this.page,
      pageSize: this.pageSize,
      keywords: this.keywords,
    };
    if (this.date && this.date.length) {
      (postParams['startOfTime'] = parseSec(1, this.date[0])), (postParams['endOfTime'] = parseSec(2, this.date[1]));
      if (this.date[1] - this.date[0] > 184 * 24 * 3600 * 1000) {
        this.$message.error('成交时间跨度不能超过6个月！');
        this.date = [this.defaultStart, this.defaultEnd];
        (postParams['startOfTime'] = parseSec(1, this.date[0])), (postParams['endOfTime'] = parseSec(2, this.date[1]));
        IPSService.successReportList({ postParams }).then((res) => {
          this.totalCount = res.count;
          this.distributeList = res.list;
        });
        return;
      }
    }
    IPSService.successReportList({ postParams }).then((res) => {
      this.totalCount = res.count;
      // 格式化数据
      this.distributeList = res.list;
    });
  }
  /* 周期 */

  /**
   * 当组建创建时
   */
  public created() {
    // 权限检测
    this.isContentBodyShow = this.$store.state.authMenuCodeList.includes('VSHOP-FUNCTION-REPORT-DISTRIBUTE');
    if (this.isContentBodyShow) {
      this.defaultStart = parseSec(3);
      this.defaultEnd = parseSec(4);
      this.date = [this.defaultStart, this.defaultEnd];
      this.getDistributeList(); // 获取分销列表
    }
  }
}
